import { render } from "./AgentStatusDetail.vue?vue&type=template&id=1003c578&scoped=true"
import script from "./AgentStatusDetail.vue?vue&type=script&lang=js"
export * from "./AgentStatusDetail.vue?vue&type=script&lang=js"

import "./AgentStatusDetail.vue?vue&type=style&index=0&id=1003c578&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1003c578"]])

export default __exports__